import useLocalize from '../../utils/hooks/useLocalize';
import NewsTabComponent from './NewsTabComponent/NewsTabComponent';
import SummaryTabComponent from './SummaryTabComponent/SummaryTabComponent';
import './TabComponent.scss';

export const TabComponent = ({ mode, setMode, symbol }) => {
  const localize = useLocalize();
  const tabs = ['summary', 'indicators', 'chart', 'news', 'historical'];
  return (
    <div>
      <div className="tab-container">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setMode(tab)}
            className={`tab-button${mode === tab ? ' active' : ''}`}
            data-testid={`tab-button-${tab}`}
          >
            {localize(`symbol.details.tab.${tab}`)}
          </button>
        ))}
      </div>
      <div>
        {mode === 'summary' && <SummaryTabComponent />}
        {mode === 'indicators' && (
          <div data-testid="tab-content-indicators">
            indicators content goes here.
          </div>
        )}
        {mode === 'chart' && (
          <div data-testid="tab-content-chart">Chart content goes here.</div>
        )}
        {mode === 'news' && (
          <NewsTabComponent symbol={symbol} newsPerPage={25} />
        )}
        {mode === 'historical' && (
          <div data-testid="tab-content-historical">
            historical content goes here.
          </div>
        )}
      </div>
    </div>
  );
};
